import { Box } from '@mui/material';
import { EnabledDocuments } from '../../../../../utils/headers';
import { useCallback } from 'react';
import DataTable from '../../../../../components/Table/DataTable';

function RolDocTypes({ items }: any) {
    const RenderTable = useCallback(() => {
        return (
            <DataTable
                headers={EnabledDocuments}
                loading={false}
                hideFooterPagination
                options={items || []}
            />
        );
    }, [items]);

    return (
        <Box
            sx={{
                '& .MuiDataGrid-virtualScroller': { height: !items?.length ? '150px' : 'inherit' }
            }}
        >
            <RenderTable />
        </Box>
    );
}

export default RolDocTypes;
